import { ArrowCounterClockwise, FunnelSimple } from "@phosphor-icons/react";

export const PERIOD_MODES = ["All", "1M", "3M", "6M", "Custom"];

export const periodRange = (mode, from, to) => {
  const now = new Date();
  if (mode === "1M" || mode === "3M" || mode === "6M") {
    const f = new Date(now);
    f.setMonth(f.getMonth() - Number(mode[0]));
    return [f.toISOString().slice(0, 10), now.toISOString().slice(0, 10)];
  }
  if (mode === "Custom") return [from || null, to || null];
  return [null, null];
};

export const inRange = (dateStr, mode, from, to) => {
  const [f, t] = periodRange(mode, from, to);
  if (!f && !t) return true;
  const d = new Date(dateStr);
  if (f && d < new Date(`${f}T00:00:00`)) return false;
  if (t && d > new Date(`${t}T23:59:59`)) return false;
  return true;
};

export default function TxnPeriodFilter({ mode, setMode, from, setFrom, to, setTo, onApply, onReset, testId = "txn-period" }) {
  const labels = { All: "All", "1M": "1 Month", "3M": "3 Months", "6M": "6 Months", Custom: "Custom" };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      {PERIOD_MODES.map((m) => (
        <button key={m} data-testid={`${testId}-${m.toLowerCase()}`}
          onClick={() => { setMode(m); if (m !== "Custom" && onApply) onApply(m); }}
          className={`text-[11px] font-semibold rounded-full px-3.5 py-1.5 border transition-colors duration-200 ${
            mode === m ? "pill-active" : "border-white/10 text-zinc-500 hover:text-zinc-200 hover:border-white/20"
          }`}>
          {labels[m]}
        </button>
      ))}
      {mode === "Custom" && (
        <>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)}
            data-testid={`${testId}-from`} className="glass-input h-8 w-auto text-xs" />
          <span className="text-xs text-zinc-500">to</span>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)}
            data-testid={`${testId}-to`} className="glass-input h-8 w-auto text-xs" />
          <button data-testid={`${testId}-apply`} onClick={() => onApply && onApply("Custom")}
            className="flex items-center gap-1.5 text-[11px] font-bold rounded-lg px-3 py-1.5 bg-emerald-500 hover:bg-emerald-400 text-[#030706] transition-colors duration-200">
            <FunnelSimple size={13} weight="bold" /> Apply Filter
          </button>
        </>
      )}
      {mode !== "All" && onReset && (
        <button data-testid={`${testId}-reset`} onClick={onReset}
          className="flex items-center gap-1.5 text-[11px] font-semibold rounded-lg px-3 py-1.5 border border-white/10 text-zinc-400 hover:text-white hover:bg-white/5 transition-colors duration-200">
          <ArrowCounterClockwise size={13} /> Reset
        </button>
      )}
    </div>
  );
}
